export default class Manufacturer {
    constructor(name, manufacturerType) {
      this.name = name;
      this.manufacturerType = manufacturerType;
    }
  }